import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import {
    DataGrid,
    GridColDef,
    GridToolbar,
    // GridColumnVisibilityModel,
    // GridColTypeDef,
    GridValueFormatterParams
} from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { staff } from "../common/type";
import ClipLoader from "react-spinners/ClipLoader";
import { getUsers } from "../services/get.service";

const Users = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false)
    const [rows, setRows] = useState<Array<staff>>([])

    useEffect(() => {
        setLoading(true);

        getUsers()
            .then((res) => {
                setLoading(false);
                setRows(res.data)
            })
            .catch((err) => {
                setLoading(false)
                console.log(err)
            })
    }, [setRows]);

    const columns: GridColDef[] = [
        { field: 'email', headerName: "Email", width: 170 },
        { field: 'isSuperAdmin', headerName: "Super Admin", width: 170, type: 'boolean' },
        { field: 'lockOutEnabled', headerName: "Lockout Enabled", width: 170, type: 'boolean' },
        {
            field: 'createdAt', headerName: "Registered Date", width: 170, type: "dateTime", valueFormatter: (val: GridValueFormatterParams<Date>) => {
                return new Date(val.value).toDateString()
            }
        },
        { field: 'phoneNumber', headerName: "Phone Number", width: 170 },
        { field: 'ownerName', headerName: "Company Name", width: 170 },
        { field: 'ownerMeleyo', headerName: "Meleyo", width: 170 },
    ]

    return <>
        <Helmet>
            <title>{t("Staffs")}</title>
        </Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full px-3 lg:px-20 py-10 pt-5">
                    <Typography variant="h4" fontSize={32} className="py-3">Users</Typography>
                    <Box sx={{ height: 520, width: "100%" }}>
                        {loading ?
                            (
                                <ClipLoader loading={loading} size={70} />
                            )
                            :
                            (
                                rows !== undefined && rows.length > 0 ?
                                    (
                                        <DataGrid rows={rows} onRowClick={(r) => console.log(r.id)
                                        } columns={columns} slots={{ toolbar: GridToolbar }} />
                                    )
                                    :
                                    <DataGrid rows={[]} columns={columns} />
                            )
                        }
                    </Box>
                </div>
            </div>
        </div>
    </>;
};

export default Users;
